<header
  class="crowdctrl-unauth-page-intro"
  [class.crowdctrl-unauth-page-intro--success]="tone === 'success'"
  [class.crowdctrl-unauth-page-intro--roomy-bottom]="roomyBottom"
>
  @if (tone === 'success') {
    <div class="crowdctrl-unauth-page-intro__success-media" aria-hidden="true">
      <ion-icon name="checkmark-circle-outline"></ion-icon>
    </div>
  }
  <div class="crowdctrl-unauth-page-intro__title-slot">
    <ng-content select="[crowdctrlUnauthIntroTitle]"></ng-content>
  </div>
  <div class="crowdctrl-unauth-page-intro__lead-slot">
    <ng-content select="[crowdctrlUnauthIntroLead]"></ng-content>
  </div>
  <div class="crowdctrl-unauth-page-intro__extra-slot">
    <ng-content select="[crowdctrlUnauthIntroExtra]"></ng-content>
  </div>
</header>
